<template>
  <CoreSelectionDrawer
    is-checked-variant
    :has-footer="!!diseases.length"
    :has-search="!!diseases.length"
    :title="title"
    :title-truncate="titleTruncate"
    :placeholder="placeholder"
    :is-back="isBack"
    :value="value"
    :items="diseases"
    :selected-item="selectedDisease"
    :loading="loading"
    :error="error"
    attach=".vue-the-doctors-filters .v-application"
    @input="$emit('input', false)"
    @back="$emit('input', false)"
    @click-item="handleClickDisease"
  >
    <template #append-header>
      <v-btn
        v-if="selectedDisease"
        color="primary"
        small
        text
        class="ml-auto"
        @click="$emit('disease:reset')"
      >
        {{ t('Сбросить', options) }}
      </v-btn>
    </template>
    <template
      v-if="!diseases.length"
      #empty-list
    >
      <div class="py-16 px-10 my-9 text-center">
        <div class="text-h6 text--text mb-2">
          {{ t('Ничего не нашлось', options) }}
        </div>
        <div class="text-body-1 text-secondary--text">
          {{ t('У врачей', options) }}
          <template v-if="townId">
            {{ t('вашего города', options) }}
          </template>
          {{ t('не заполнены эти данные', options) }}
        </div>
      </div>
    </template>
    <template #footer>
      <slot
        name="footer"
        v-bind="{ selectedDisease }"
      />
    </template>
  </CoreSelectionDrawer>
</template>

<script setup lang="ts">
import {
  computed,
  ref,
  toRefs,
  watch,
} from 'vue'
import I18NextVue from 'i18next'
import apiDiseases from 'www/vue_components/common/TheFilters/doctors/api/apiDiseases'
import CoreSelectionDrawer from 'src/core/CoreSelectionDrawer/CoreSelectionDrawer.vue'
import type { ApiDiseaseParamsGet } from 'www/vue_components/common/TheFilters/doctors/api/apiDiseases.types'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input', 'disease:selected', 'disease:reset'])

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const props = defineProps<{
  value: boolean
  isBack?: boolean
  title: string
  titleTruncate?: boolean
  placeholder?: string
  townId?: ApiDiseaseParamsGet['town_id']
  pageType: ApiDiseaseParamsGet['page_type']
  specialityId: ApiDiseaseParamsGet['speciality_id']
  selectedDisease: Filters['disease']
}>()

const {
  value: isVisibleModal, townId, specialityId, pageType,
} = toRefs(props)

const loading = ref(false)
const error = ref(false)

const diseases = ref<NonNullable<Filters['disease']>[]>([])
const diseasesCache: Map<string, NonNullable<Filters['disease']>[]> = new Map()

const loadDiseases = async () => {
  error.value = false
  loading.value = true

  try {
    const requestData = {
      town_id: townId?.value,
      speciality_id: specialityId.value,
      page_type: pageType.value,
    }
    const cacheKey = JSON.stringify(requestData)

    if (!diseasesCache.has(cacheKey)) {
      const { data } = await apiDiseases.get(requestData)

      diseasesCache.set(cacheKey, data)
    }

    diseases.value = diseasesCache.get(cacheKey) || []
  } catch {
    error.value = true
  } finally {
    loading.value = false
  }
}

watch(isVisibleModal, async () => {
  if (isVisibleModal.value) {
    await loadDiseases()
  }
})

const handleClickDisease = (disease: NonNullable<Filters['disease']>) => {
  emit('disease:selected', disease)
}
</script>
